import { VoucherStatus } from "@gymflow/types";

import { DotBadgeProps } from "../../atoms/DotBadge";

const VoucherStatusToColor = {
  PENDING_PAYMENT: "warning",
  AVAILABLE: "secondary",
  REDEEMED: "success",
  REFUNDED: "gray",
  VOID: "error",
} satisfies {
  [key in VoucherStatus]: DotBadgeProps["intent"];
};

export { VoucherStatusToColor };
